import { Component, ElementRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';
@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'respuesta-al-frente';
  isAuthenticated!: boolean;
  userData: any;
  constructor(
    private readonly authService: AuthService,
    private _elementRef: ElementRef
  ) {
    this.userData = this.authService.getUserData();
  }
  ngOnInit(): void {
    this._elementRef.nativeElement.removeAttribute("ng-version");
  }
}
